<template>
  <div>
    <BaseTitle :title="$t('content.class_accel_list')" />
    <v-card>
      <div>
        <div class="pa-5 d-flex justify-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.class_accel_list') }}</div>

          <v-checkbox v-model="classAcceleration" :loading="loadingLoad" color="indigo darken-3" light hide-details @change="changeStatus">
            <template #label>
              <strong class="white--text">{{ $t('content.active_accel') }}</strong></template
            >
          </v-checkbox>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div v-if="permissionButton('ROLE_CLASS_LEVEL_MANAGEMENT_CREATE') && classAcceleration === true">
              <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" v-if="user.roleId !== 6" @click="add">{{ $t('add') }}</v-btn>
            </div>

            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.userId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="ic_setting_class" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">
                    {{ $t('content.class_accel') }} <span class="primary--text">{{ item.gradeFrom }}</span> {{ $t('to') }} {{ $t('menu.class') }}
                    <span class="primary--text">{{ item.gradeTo }}</span>
                  </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('form.status') }}:
                      <strong v-if="item.status" class="green--text font-italic">{{ $t('active') }}</strong>
                      <strong v-else class="red--text font-italic">{{ $t('inactive') }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1" v-if="user.roleId === 2 && classAcceleration === true">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissionButton('ROLE_CLASS_LEVEL_MANAGEMENT_UPDATE')">
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <div v-if="permissionButton('ROLE_CLASS_LEVEL_MANAGEMENT_DELETE')">
                        <v-list-item>
                          <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
      </div>
    </v-card>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
// import TableHeader from '@/components/table/TableHeader';
// import TableFooter from '@/components/table/TableFooter';
import NoData from '@/components/table/NoData';

export default {
  name: 'ClassAccelList',
  components: {
    BaseTitle,
    // TableHeader,
    // TableFooter,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'ClassAccel/items',
      user: 'Auth/user',
      permission: 'Auth/permission'
    }),
    tableHeader() {
      return [
        { text: this.$t('table.grade'), value: 'name' },
        { text: this.$t('table.access_parent'), value: 'parentAccess' },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 180 }
      ];
    }
  },
  data: () => ({
    dialogDelete: false,
    currentItem: null,
    listData: [],
    search: '',
    loadingLoad: false,
    table: {
      loading: false,
      options: {}
    },
    classAcceleration: false,
    allPositionNull: '',
    positionNullExist: ''
  }),
  methods: {
    getValidationCheck() {
      this.$store.dispatch('ClassAccel/positionStatus').then(data => {
        this.allPositionNull = data.allPositionNull;
        this.positionNullExist = data.positionNullExist;
      });
    },
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    onPopUp() {
      this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_class_level_index') });
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('ClassAccel/fetchList', {
          search: this.search
        })
        .then(data => (this.listData = data))
        .finally(() => (this.loadingLoad = false));
    },
    getStatus() {
      this.loadingLoad = true;
      this.$store
        .dispatch('ClassAccel/classStatus')
        .then(data => {
          this.classAcceleration = data.classAcceleration;
        })
        .finally(() => (this.loadingLoad = false));
    },
    changeStatus() {
      this.loadingLoad = true;
      const payload = { classAcceleration: this.classAcceleration };
      this.$store
        .dispatch(`ClassAccel/updateStatus`, payload)
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.loadingLoad = false;
          this.getData();
          this.getStatus();
        });
    },
    add() {
      if (this.allPositionNull) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.class_level_set') });
      } else {
        this.$router.push({ name: 'CreateClassAccel' });
        if (this.positionNullExist) {
          this.$store.dispatch('general/showErrorNotification', { message: this.$t('content.class_level_set') });
        }
      }
    },
    editItem({ classAccelerationId: id }) {
      this.$router.push({ name: 'EditClassAccel', params: { id } });
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;

      this.table.loading = true;
      this.$store
        .dispatch('ClassAccel/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .finally(() => (this.table.loading = false));
    }
  },
  created() {
    this.getData();
    this.getStatus();
    this.getValidationCheck();
    this.$store.commit('table/RESET_PAGEABLE');
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
